import type React from 'react';
import styles from './Hero.module.css';
import { Button } from '../../core/Button';

export const Hero: React.FC = () => {
  return (
    <div className={styles.hero}>
      <h1 className={styles.title}>Create and Export Beautiful Shaders</h1>
      <p className={styles.subtitle}>
        The ultimate tool for designers to create, customize, and export shaders
        for their websites.
      </p>
      <div className={styles.actions}>
        <Button>
          <a href="/signup">Get Started for Free</a>
        </Button>
      </div>
    </div>
  );
};
